import { IonRippleEffect, IonSpinner } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';

import './Button.scss';
import { uiButtonClassNames } from './class-names';
import { UiButtonProps } from './types';

export const UiButtonBase = React.forwardRef<HTMLButtonElement, UiButtonProps>(
  function UiButton(
    {
      align = 'center',
      children,
      onClick,
      size = 'medium',
      expand = 'block',
      type = 'button',
      variant = 'primary',
      round = 'md',
      icon,
      disabled,
      className,
      pending,
      TEST_ID,
      theme,
      ...props
    },
    ref,
  ) {
    const [isActive, setIsActive] = React.useState(false);

    const classes = classNames(
      uiButtonClassNames.root,
      'ion-activatable ripple-parent rounded-rectangle',
      uiButtonClassNames.size(size),
      uiButtonClassNames.round(round),
      uiButtonClassNames.variant(variant),
      uiButtonClassNames.expand(expand),
      uiButtonClassNames.align(align),
      {
        disabled: disabled || pending,
        'theme-light': theme === 'light',
        'theme-dark': theme === 'dark',
        [uiButtonClassNames.iconOnly]: !children && !!icon,
        [uiButtonClassNames.active]: isActive,
      },
      className,
    );

    const activeteActiveState = () => {
      setIsActive(true);
    };

    const deactivateActiveState = () => {
      setIsActive(false);
    };

    return (
      <button
        className={classes}
        onClick={onClick}
        type={type}
        disabled={disabled}
        data-testid={TEST_ID}
        ref={ref}
        onTouchStart={activeteActiveState}
        onTouchEnd={deactivateActiveState}
        onMouseDown={activeteActiveState}
        onMouseUp={deactivateActiveState}
        onMouseEnter={activeteActiveState}
        onMouseLeave={deactivateActiveState}
        {...props}
      >
        {icon && <span className={uiButtonClassNames.icon}>{icon}</span>}
        {children}
        {pending && <IonSpinner className={uiButtonClassNames.spinner} />}
        <IonRippleEffect />
      </button>
    );
  },
);
